module.exports = __webpack_public_path__ + "static/media/curved lines.27a34083.svg";